import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { queryEventsCount, QueryEventsCountParams } from "supabase/events";

export const useQueryEventsCount = (params: QueryEventsCountParams) => {
  const { eventType, title, startDate, endDate, isMunicipality, userUid, madeByOrganizer } = params;

  const {
    isLoading,
    isFetching,
    isError,
    error,
    data: eventsCount,
  } = useQuery({
    queryKey: ["events", "counts", eventType, { title, startDate, endDate, isMunicipality, userUid, madeByOrganizer }],
    queryFn: () => {
      return queryEventsCount(params);
    },
    placeholderData: keepPreviousData,
  });

  return { isLoading, isFetching, isError, error, eventsCount };
};
